var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 177.356,
    viewBox: "0 0 1920 177.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wave",
    d: "M0,301.66l64-17.7c64-17.7,192-53.111,320-82.654,128-29.1,256-53.443,384-35.407,128,17.372,256,77.122,384,94.493,128,18.036,256-6.307,384,0,128,5.864,256,41.272,320,58.975l64,17.7H0Z",
    transform: "translate(0 -159.712)",
    fill: "#061136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.701a58c8d507e6359d411e797c5939bd.svg";
export { ForwardRef as ReactComponent };